module.exports = __webpack_public_path__ + "static/media/twitter.7140220d.svg";